import _regeneratorRuntime from 'babel-runtime/regenerator';
var _this = this;
function _asyncToGenerator(fn) {
  return function () {
    var gen = fn.apply(this, arguments);
    return new Promise(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);
          var value = info.value;
        } catch (error) {
          reject(error);
          return;
        }
        if (info.done) {
          resolve(value);
        } else {
          return Promise.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }
      return step("next");
    });
  };
}
import level1SubscriptionService from '../../services/subscriptions/level1SubscriptionService';
import { callAPI } from './apiActions';
import get from 'lodash/get';
export var LEVEL1_LOADED = 'LEVEL1_LOADED';
export var getAllLevel1Data = function getAllLevel1Data(instruments) {
  return function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(dispatch, getState) {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return dispatch(callAPI('GetLevel1Summary', {
                OMSId: get(getState(), 'user.userInfo.OMSId', 1)
              })).then(function (res) {
                return res.forEach(function (el) {
                  var data = JSON.parse(el);
                  dispatch(addLevel1(data.InstrumentId, data));
                });
              });
            case 2:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }));
    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();
};

/**
 * 1) Tell server to subscribe to level1 data for passed `instrumentId`
 * 2) Get first portion of data
 */
export var getLevel1Data = function getLevel1Data(instrumentId) {
  return function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(dispatch) {
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return level1SubscriptionService.initSubscribtion(instrumentId).then(function (updates) {
                return dispatch(addLevel1(instrumentId, updates));
              }).catch(function () {});
            case 2:
              return _context2.abrupt('return', _context2.sent);
            case 3:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this);
    }));
    return function (_x3) {
      return _ref2.apply(this, arguments);
    };
  }();
};
export var subscribeToLevel1 = function subscribeToLevel1(selectedInstrumentId) {
  return function (dispatch) {
    level1SubscriptionService.subscribe(function (updates) {
      dispatch(addLevel1(updates.InstrumentId, updates));
    });
  };
};
export var unsubscribeLevel1 = function unsubscribeLevel1(instrumentId) {
  return function (dispatch) {
    level1SubscriptionService.stopOne(instrumentId);
  };
};
export var unsubscribeAllLevel1 = function unsubscribeAllLevel1() {
  return function (dispatch) {
    level1SubscriptionService.stopAll();
  };
};
export var addLevel1 = function addLevel1(instrumentId, level1Data) {
  return {
    type: LEVEL1_LOADED,
    payload: {
      instrumentId: instrumentId,
      level1Data: level1Data
    }
  };
};